// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keys from "../utils/keys";

export const tokenApi = createApi({
  reducerPath: "tokenApi",
  baseQuery: fetchBaseQuery({ baseUrl: keys.baseUrl }),
  tagTypes: ["tokenBalance"],
  endpoints: (builder) => ({
    tokenBalance: builder.query({
        query: (params) => ({
          url: `tokens/balance?user_id=${params.userId}`,
          method: "GET",
        }),
        providesTags: ["tokenBalance"],
        transformResponse: (response: any) => {
          return response;
        },
      }),
    tokenCost: builder.query({
        query: () => ({
          url: `tokens/cost`,
          method: "GET",
        }),
        transformResponse: (response: any) => {
          return response;
        },
      }),
  }),
});
export const {
  useTokenBalanceQuery,
  useTokenCostQuery
} = tokenApi;
